import { render } from "./HeaderTab.vue?vue&type=template&id=8ccc087a&scoped=true"
import script from "./HeaderTab.vue?vue&type=script&lang=js"
export * from "./HeaderTab.vue?vue&type=script&lang=js"

import "./HeaderTab.vue?vue&type=style&index=0&id=8ccc087a&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccc087a"]])

export default __exports__